<template>
  <div class="main-content">
    <div class="list_header" v-if="listHeader">
      {{ listHeader }}
      <div
        class="result_search"
      >
        <p>検索結果{{spaceList.length}}件</p>
        <select class="sort" @change="handleSort">
          <option
              class="select-option"
              :value="item.label"
              v-for="(item, index) in sortType"
              :key="index"
            >
              {{ item.value }}
            </option>
        </select>
      </div>
    </div>
    <div class="list_header_item">
      <router-link
        v-for="(item) in spaceList"
        style="cursor: pointer; color: #000000; text-decoration: none"
        :key="item.id"
        class="content_space_rent_item"
        :to="handelGotoDetailSpace(item.display_id)"
      >
        <div class="card-body">
          <div class="content_space_rent_item_img">
            <img
              class="space_image"
              :src="ImageResizing(item.image_url, '30', true)"
              :alt="item.generalBasicSpaceNameJa"
              style="
                width: 100%;
                height: 100%;
                border-radius: 4px;
                cursor: pointer;
                min-height: 200px;
              "
            />

            <div
              class="bestrate-ribbon"
              v-if="item.generalBasicSpaceManageType"
            >
              <img
                v-if="
                  item.generalBasicSpaceManageType === 'our-company' ||
                  item.generalBasicSpaceManageType === 'own-company-skima' ||
                  item.generalBasicSpaceManageType === 'management-our-brand'
                "
                :src="bestRateIcon"
                :alt="item.generalBasicSpaceNameJa + `- ベストレート`"
                style="width: 50px; height: 55px"
              />
            </div>
            <div class="bestrate-ribbon" v-else>
              <img
                v-if="
                  item.manage_type === 'our-company' ||
                  item.manage_type === 'own-company-skima' ||
                  item.manage_type === 'management-our-brand'
                "
                :src="bestRateIcon"
                :alt="item.generalBasicSpaceNameJa + `- ベストレート`"
                style="width: 50px; height: 55px"
              />
            </div>
            <div class="new-ribbon" v-if="isNew(item)">
              <img :src="newIcon" alt="new" />
            </div>
          </div>
          <div v-if="nameGroupArea">
            <div class="label-number-red" v-if="(item.rental_space_sort_order_position && item.rental_space_sort_order_position <= 6) && nameGroupArea">
              <span class="name-area">{{ nameGroupArea }}の</span>
              <span class="number"
                >おすすめ
                <p>{{ item.rental_space_sort_order_position }}位</p></span
              >
            </div>
          </div>
          <div v-else>
            <div class="label-number-red" v-if="(item.rental_space_sort_order_position && item.rental_space_sort_order_position <= 6) && item?.areas?.name">
              <span class="name-area">{{ item?.areas?.name }}の</span>
              <span class="number"
                >おすすめ
                <p>{{ item.rental_space_sort_order_position }}位</p></span
              >
            </div>
          </div>


          <div class="discount-ribbon" v-if="isDiscount(item)">
            <span>
              <p>Discount</p>
            </span>
          </div>
          <div class="basic-info">
            <h3 class="space-name">{{ item.generalBasicSpaceNameJa }}</h3>
            <div class="favorite-container">
              <img
                v-if="item?.like"
                :src="HeartRed"
                class="favorite-icon"
                alt="favorite icon"
                @click.prevent="handleFavoriteSpaceId(item?.id, item)"
              />
              <img
                v-else
                :src="HeartGray"
                class="favorite-icon"
                alt="favorite icon"
                @click.prevent="handleFavoriteSpaceId(item?.id, item)"
              />
            </div>
            <div class="flex w-full justify-between align-center flex-wrap gap-[3px]">
              <PanoramaButton 
                :spaceInfo="item" 
                outerClass="main-panorama-degree-tour-recommend"
                innerClass="panorama-degree-tour-recommend"
              />
              <div class="price" style="width: unset;">
                {{
                  Math.floor(item?.per_person_price * 1.1).toLocaleString()+ '円'
                }}〜/1H
              </div>
            </div>
            
            <div class="address">
              <span>{{ item?.generalLocationPrefecture }}{{ item?.generalLocationMunicipality }}{{ item?.generalLocationAddressJa }}</span>
            </div>
            <div class="info-group">
              <div class="station" v-if="item?.walking_duration !==null && item?.walking_duration !==undefined">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="8"
                  height="13"
                  viewBox="0 0 8 13"
                  fill="none"
                >
                  <path
                    d="M3.7575 1.87088C3.7575 1.25088 4.2575 0.740875 4.8875 0.740875C5.5175 0.740875 6.0175 1.24088 6.0175 1.87088C6.0175 2.50088 5.5175 3.00088 4.8875 3.00088C4.2575 3.00088 3.7575 2.50088 3.7575 1.87088ZM2.9675 5.42088C2.9675 5.42088 2.9275 5.44088 2.8975 5.45088L2.7075 5.53088C2.3275 5.70088 2.0275 6.03088 1.8975 6.43088L1.8375 6.61088C1.7075 7.00087 1.2775 7.21088 0.8875 7.08088C0.4975 6.95088 0.2875 6.52087 0.4175 6.13088L0.4775 5.95088C0.7475 5.15088 1.3375 4.50088 2.1075 4.16088L2.2975 4.08088C2.7875 3.86088 3.3075 3.75088 3.8475 3.75088C4.8975 3.75088 5.8375 4.38088 6.2375 5.34088L6.5975 6.20088L7.0975 6.45088C7.4675 6.64088 7.6175 7.09088 7.4375 7.46088C7.2475 7.83087 6.7975 7.98088 6.4275 7.80088L5.7975 7.49088C5.5575 7.37088 5.3675 7.17088 5.2675 6.92088L5.0375 6.38088L4.5875 7.92088L5.7475 9.19088C5.8775 9.33088 5.9675 9.49088 6.0075 9.68087L6.5475 11.8409C6.6475 12.2409 6.4075 12.6509 5.9975 12.7509C5.5975 12.8509 5.1875 12.6109 5.0875 12.2009L4.5675 10.1409L2.9075 8.33088C2.5575 7.95088 2.4275 7.43088 2.5675 6.93088L2.9675 5.44088V5.42088ZM1.6175 10.0809L2.2075 8.62088C2.2575 8.69088 2.3175 8.76087 2.3675 8.82088L3.3175 9.86088L2.9775 10.7109C2.9175 10.8509 2.8375 10.9809 2.7275 11.0909L1.2775 12.5409C0.9875 12.8309 0.5075 12.8309 0.2175 12.5409C-0.0725 12.2509 -0.0725 11.7709 0.2175 11.4809L1.6075 10.0909L1.6175 10.0809Z"
                    fill="#333333"
                  />
                </svg>
                <span
                  >{{ item?.station_name }}駅徒歩{{ item?.walking_duration }}分</span
                >
              </div>
              <div class="time">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="11"
                  viewBox="0 0 11 11"
                  fill="none"
                >
                  <path
                    d="M5.50853 0.757202C2.74853 0.757202 0.513535 2.9972 0.513535 5.7572C0.513535 8.5172 2.74853 10.7572 5.50853 10.7572C8.27353 10.7572 10.5135 8.5172 10.5135 5.7572C10.5135 2.9972 8.27353 0.757202 5.50853 0.757202ZM7.15853 8.1122L5.01353 5.9622V3.2572H6.01353V5.5522L7.86853 7.4072L7.15853 8.1122Z"
                    fill="#333333"
                  />
                </svg>
                <span>{{ item?.minimum_usage_time }} 分〜</span>
              </div>
              <div class="people">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="13"
                  viewBox="0 0 14 13"
                  fill="none"
                >
                  <path
                    d="M10.9302 11.4447V10.403C10.9302 9.8505 10.7107 9.3206 10.32 8.9299C9.92931 8.5392 9.3994 8.3197 8.84687 8.3197H4.6802C4.12767 8.3197 3.59777 8.5392 3.20706 8.9299C2.81636 9.3206 2.59687 9.8505 2.59687 10.403V11.4447"
                    stroke="#333333"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6.76353 6.23637C7.91413 6.23637 8.84687 5.30363 8.84687 4.15304C8.84687 3.00244 7.91413 2.0697 6.76353 2.0697C5.61294 2.0697 4.6802 3.00244 4.6802 4.15304C4.6802 5.30363 5.61294 6.23637 6.76353 6.23637Z"
                    stroke="#333333"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>
                  〜{{ item?.generalSpaceInformationMaximumCapacity }}名
                </span>
              </div>
              <div class="area">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="11"
                  viewBox="0 0 11 11"
                  fill="none"
                >
                  <g clip-path="url(#clip0_3426_358)">
                    <path
                      d="M6.7323 0.757202H9.5448C9.80457 0.757202 10.0135 0.966187 10.0135 1.22595V4.03845C10.0135 4.22791 9.90027 4.39978 9.72449 4.47205C9.54871 4.54431 9.34753 4.50525 9.21277 4.37048L8.45105 3.60876L6.75183 5.30798C6.56824 5.49158 6.27136 5.49158 6.08972 5.30798L5.46472 4.68298C5.28113 4.49939 5.28113 4.20251 5.46472 4.02087L7.16394 2.32166L6.40027 1.55798C6.2655 1.42322 6.22644 1.22205 6.29871 1.04626C6.37097 0.870483 6.54285 0.757202 6.7323 0.757202ZM3.2948 10.7572H0.4823C0.222534 10.7572 0.0135498 10.5482 0.0135498 10.2885V7.47595C0.0135498 7.2865 0.126831 7.11462 0.302612 7.04236C0.478394 6.97009 0.679565 7.00916 0.814331 7.14392L1.57605 7.90564L3.27527 6.20642C3.45886 6.02283 3.75574 6.02283 3.93738 6.20642L4.56238 6.83142C4.74597 7.01501 4.74597 7.31189 4.56238 7.49353L2.86316 9.19275L3.62488 9.95447C3.75964 10.0892 3.79871 10.2904 3.72644 10.4662C3.65417 10.642 3.4823 10.7552 3.29285 10.7552L3.2948 10.7572Z"
                      fill="#333333"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3426_358">
                      <rect
                        width="10"
                        height="10"
                        fill="white"
                        transform="translate(0.0135498 0.757202)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <span>〜{{ item?.acreage }}㎡</span>
              </div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import "./ListSpace.scss";
import { ref, watch, inject } from "vue";
import { ROUTER_PATH } from "@/client/const";
import { getDateTime } from "@/client/const/search";
import { ImageResizing } from "@/client/utils";
import bestRateIcon from "@/client/assets/images/bestrateIcon.png";
import { getListSpaceByLocationApi, createOrDeleteFavoriteApi } from "@/client/api";
import moment from "moment";
import { useRoute, useRouter } from "vue-router";
import useStoreCustomer from "@/client/store/Customer";
import HeartRed from "@/client/assets/icons/heart-red-icon.svg";
import HeartGray from "@/client/assets/icons/heart-gray-icon.svg";
import newIcon from "@/client/assets/images/spaces/spaceItem/new.svg";
import PanoramaButton from '@/client/components/Space/PanoramaButton.vue';
export default {
  name: "ListSpace",
  components: {
    PanoramaButton
  },
  props: {
    listHeader: String,
    dataList: Array,
    nameGroupArea: String,
  },
  setup(props) {
    const spaceList = ref();
    const discountData = ref([]);
    const route = useRoute();
    const router = useRouter();
    const storeCustomer = useStoreCustomer();
    const toast = inject("$toast");
    const sortType = ref([
      {label: 'suggest', value: 'おすすめ順'},
      {label: 'large_area', value: '面積広い順'},
      {label: 'narrow_area', value: '面積狭い順'},
      {label: 'accommodates_many_people', value: '収容人数多い順'},
      {label: 'accommodates_few_people', value: '収容人数少ない順'},
      {label: 'walk_few_minutes_station', value: '駅から近い順'},
    ]);
    const dataRouter = ref({
      ar: route.query.ar ? route.query.ar : '',
      ctg: route.query.ctg ? route.query.ctg : '',
      pp: route.query.pp? route.query.pp : '',
      dt: route.query.dt ? route.query.dt : '',
    });
    const handelGotoDetailSpace = (id) => {
      return `${ROUTER_PATH.DETAIL}/${id}`;
    };

    watch(props, () => {
      listCheck();
    });

    const listCheck = () => {
      if (props.dataList?.length) {
        spaceList.value = props.dataList.map((data) => ({
          ...data,
          bestrate: /our/g.test(data.generalBasicSpaceManageType),
        }));

      } else {
        spaceList.value = {};
      }
    };
    listCheck();
    const isNew = (data) => {
      if (data.created_at == null) {
        return false;
      }
      const current = new Date().getTime();
      const createdAt = new Date(data.created_at).getTime();

      const diff = Math.floor((current - createdAt) / 86400000);
      return diff <= 30;
    };

    const isDiscount = (data) => {
      const discountIdList = discountData.value.map((item) => {
        return item.rental_space_id;
      });

      if (!discountIdList.includes(data.id)) {
        return false;
      }

      const discount = discountData.value.find(
        (item) => item.rental_space_id === data.id
      );

      const current = new Date();
      const startDate = new Date(moment(discount.start_date + " 00:00:00"));
      if (!discount.end_date && startDate.getTime() <= current.getTime()) {
        return true;
      }
      const endDate = new Date(moment(discount.end_date + " 23:59:59"));

      if (
        startDate.getTime() > current.getTime() ||
        endDate.getTime() < current.getTime()
      ) {
        return false;
      }
      return true;
    };

    const handleSort = async (event) => {
      storeCustomer.isLoading = true;
      let selectValue = event.target.value;
      let peopleData = [];
      if (dataRouter.value.pp != "") {
        let people = dataRouter.value.pp.split("-").filter(Boolean);
        if (people.length == 1) {
          peopleData["case_person"] = people[0];
        } else if (people.length == 2) {
          peopleData["from"] = people[0];
          peopleData["to"] = people[1];
        }
      }
      const [selectedDate, timeStart, timeEnd] = getDateTime(dataRouter.value?.dt);
      let dataSearch = {
        area_id: dataRouter.value.ar,
        selectedDate: selectedDate,
        timeStart: timeStart,
        timeEnd: timeEnd,
        ts_category_spaces_id: dataRouter.value.ctg,
        people_count: {},
        status: 'published',
        no_paginate: true,
        fe: 'vn'
      };
      if ("from" in peopleData) {
        dataSearch.people_count.from = peopleData["from"];
      }
      if ("to" in peopleData) {
        dataSearch.people_count.to = peopleData["to"];
      }
      if ("case_person" in peopleData) {
        dataSearch.people_count.case_person = peopleData["case_person"];
      }

      if (selectValue == 'large_area') {
        dataSearch = {
          ...dataSearch,
          search_sort: 'largeArea'
        }
      }

      if (selectValue == 'narrow_area') {
        dataSearch = {
          ...dataSearch,
          search_sort: 'narrowArea'
        }
      }

      if (selectValue == 'accommodates_many_people') {
        dataSearch = {
          ...dataSearch,
          search_sort: 'accommodatesManyPeople'
        }
      }

      if (selectValue == 'accommodates_few_people') {
        dataSearch = {
          ...dataSearch,
          search_sort: 'accommodatesFewPeople'
        }
      }

      if (selectValue == 'walk_few_minutes_station') {
        dataSearch = {
          ...dataSearch,
          search_sort: 'walkFewMinutesStation'
        }
      }

      try {
        storeCustomer.isLoading = true;
        const res = await getListSpaceByLocationApi(dataSearch);
        spaceList.value = await res.data.data.map((item) => ({
            ...item,
            image_url:
            item.rental_space_image.length != 0
                ? `${item.rental_space_image[0].url_image}`
                : "",
        }));
      } catch (error) {
        toast.error("has error");
      } finally {
        storeCustomer.isLoading = false;
      }
    };

    const handleFavoriteSpaceId = async (spaceId, item_space) => {
      item_space.like = !item_space?.like;
      try {
        await createOrDeleteFavoriteApi(spaceId, {});
      } catch (error) {
        item_space.like = !item_space?.like;
        if(error?.status == 401) {
          const redirectParameters = {
                path: route.path,
                query: {
                  ...route.query,
                },
              }
          sessionStorage.setItem("redirectParameters", JSON.stringify(redirectParameters));
          sessionStorage.setItem("favoriteSpaceId", JSON.stringify(spaceId));
          return router.push(ROUTER_PATH.LOGIN);
        }
      }
    };

    return {
      handelGotoDetailSpace,
      spaceList,
      bestRateIcon,
      isNew,
      isDiscount,
      sortType,
      handleSort,
      handleFavoriteSpaceId,
      HeartRed,
      HeartGray,
      newIcon,
      ImageResizing
    };
  },
};
</script>

<style></style>
